import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  WidgetFrame,
  ProgressWidget,
  ErrataWidget,
  Text,
} from "../../../personal-studio-components/studio";
import { StudentService } from "../../components/studentService";
//from "../../Config.js";
import * as cls from "./Credentials.module.scss";
import imgDefaultAvatar from "./avatar.svg";
import ModalChangePassword from "../../components/modalChangePassword/ModalChangePassword";
export { Credentials };
/**
 * Страница Профиль / Учетные данные
 */
function Credentials({}) {
  const title = "Учетные данные";
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);

  const [response, setResponse] = useState(null);
  const request = {
    method: "post",
    path: "/student/info",
    data: {
      access_token,
      study_contract_id: contractId,
    },
  };
  useEffect(() => {
    StudentService.send(request, setResponse);
  }, [access_token, contractId]);
  if (!response) return <ProgressWidget title={title} />;
  if (response.errors) return <ErrataWidget errata={response} />;
  const model = CredentialsModel.importStudentInfo(contractId, response);
  return <CredentialsView model={model} />;
}
class CredentialsModel {
  constructor(props) {
    Object.assign(this, props);
  }
  getContractDate() {
    return this.contract_scan_date
      ? new Date(this.contract_scan_date).toLocaleDateString()
      : "";
  }
  getSemesterView() {
    return this.kurs + " Курс / " + this.semester + " Семестр";
  }
  getExportURL() {
    return this.toCSV({
      Фамилия: this.sur_name,
      Имя: this.name,
      Отчество: this.sec_name,
      "E-mail": this.user_email,
      "Образовательная организация": this.vuz_name,
      "ID контракта": this.contract_number,
      "Платежный код": this.pay_contract,
      "Номер Договора на обучение": this.contract_scan_number,
      "Дата заключения договора на обучение": this.getContractDate(),
      "Срок обучения": this.study_period,
      Направление: this.direction,
      "Форма обучения": this.form,
      Уровень: this.final_stage,
      "Текущий курс обучения": this.getSemesterView(),
      "Адрес офиса": this.ic_address,
      Телефон: this.ic_phone,
      "Научный руководитель": this.vkr_advisor,
      "Тема ВКР": this.vkr_theme,
    });
  }
  toCSV(data) {
    let code = "";
    for (const key in data)
      code += this.quote(key) + "," + this.quote(data[key]) + "\n";
    return this.toDataURL(code);
  }
  quote(str) {
    return '"' + String(str).replace(/"/g, '""') + '"';
  }
  toDataURL(str) {
    const cp1251 =
      "ЂЃ‚ѓ„…†‡€‰Љ‹ЊЌЋЏђ‘’“”•–—�™љ›њќћџ ЎўЈ¤Ґ¦§Ё©Є«¬*®Ї°±Ііґµ¶·\
ё№є»јЅѕїАБВГДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯабвгдежзийклмнопрстуфхцчшщъыьэюя";
    let url = "data:text/csv;charset=cp1251,";
    for (const char of str) {
      const i = cp1251.indexOf(char);
      const b = i >= 0 ? i + 128 : char.charCodeAt(0);
      let h = Number(b).toString(16);
      if ("a" == h) h = "0A";
      url += "%" + h;
    }
    return url;
  }
  static importStudentInfo(contractId, studentInfo) {
    const contractInfo = studentInfo.contracts[contractId];
    console.assert(
      contractInfo,
      "Отсутствуют данные contracts /",
      contractId,
      studentInfo
    );
    return new CredentialsModel({ ...studentInfo, ...contractInfo });
  }
}
function CredentialsView({ model }) {
  const [isSwowModal, setIsShowModal] = useState(false);

  const NONE = <Text type="danger">???</Text>;
  const Comment = ({ children }) => <Text type="danger"> {children} </Text>;
  const contract_date = model.getContractDate();
  const semester = model.getSemesterView();
  const menu = [
    {
      icon: "download",
      name: "Выгрузить данные",
      href: model.getExportURL(),
      download: "credentials.csv",
    },
  ];
  return (
    <>
      <h1>Учётные данные</h1>
      <WidgetFrame icon="survey" title="Данные профиля">
        <AttributeList>
          <Avatar src={imgDefaultAvatar} role="Студент" name={model.fio} />
          <Attribute name="Фамилия" value={model.sur_name} />
          <Attribute name="Имя" value={model.name} />
          <Attribute name="Отчество" value={model.sec_name} />
          <Attribute name="E-mail" value={model.user_email} />
          <AttributeLink
            name="Сменить пароль"
            href="#password"
            onClick={onPassword}
          />
        </AttributeList>
      </WidgetFrame>
      <WidgetFrame icon="survey" title="Данные об обучении" menu={menu}>
        <AttributeList>
          <Attribute
            name="Образовательная организация"
            value={model.vuz_name}
            span={2}
          />
          <Attribute name="ID контракта" value={model.contract_number} />
          <Attribute name="Платежный код" value={model.pay_contract} />
          <Attribute
            name="Номер Договора на обучение"
            value={model.contract_scan_number}
          />
          <Attribute
            name="Дата заключения договора на обучение"
            value={contract_date}
          />
          <Attribute name="Срок обучения" value={model.study_period} />
          <Attribute name="Направление" value={model.direction} />
          <Attribute name="Форма обучения" value={model.form} />
          <Attribute name="Уровень" value={model.final_stage} />
          {!model.is_dpo && (
            <Attribute name="Текущий курс обучения" value={semester} />
          )}
        </AttributeList>
      </WidgetFrame>
      <WidgetFrame icon="survey" title="Данные Айдинг-центра">
        <AttributeList>
          <Attribute name="Адрес офиса" value={model.ic_address} />
          <Attribute name="Телефон" value={model.ic_phone} />
        </AttributeList>
      </WidgetFrame>
      {model.vkr_theme && (
        <WidgetFrame
          icon="survey"
          title="Данные о научном руководителе и теме ВКР"
        >
          <AttributeList>
            <Attribute name="Научный руководитель" value={model.vkr_advisor} />
            <Attribute name="Тема ВКР" value={model.vkr_theme} />
          </AttributeList>
        </WidgetFrame>
      )}
      {isSwowModal && (
        <ModalChangePassword
          isSwowModal={isSwowModal}
          setIsShowModal={setIsShowModal}
        />
      )}
    </>
  );
  async function onPassword(event) {
    setIsShowModal(true);
  }
}
function AttributeList({ children }) {
  return <div className={cls.attribute_list}>{children}</div>;
}
function Attribute({ name, value, span }) {
  let className = cls.attribute;
  if (span > 1) className += " " + cls.span2;
  return (
    <div className={className}>
      <div className={cls.attribute_name}>{name}</div>
      <div className={cls.attribute_value}>{value}</div>
    </div>
  );
}
function AttributeLink({ name, href, target, onClick }) {
  return (
    <div className={cls.attribute_link + " " + cls.span2}>
      <a href={href} target={target} onClick={onClick}>
        {name}
      </a>
    </div>
  );
}
function Avatar({ src, role, name }) {
  return (
    <div className={cls.avatar + " " + cls.span2}>
      <img className={cls.avatar_image} src={src} />
      <div className={cls.avatar_label}>
        <div className={cls.avatar_role}>{role}</div>
        <div className={cls.avatar_name}>{name}</div>
      </div>
    </div>
  );
}
